import BaseApi from './BaseApi';
import { Channel } from '../../components/common/ChimeChatList';

/**
 * 問合せ一覧(チャットチャネル)の取得用API。
 */
class GetListChannelsApi extends BaseApi {
  async get() {
    return await this.execute('getListChannelsApi', {
      method: 'GET'
    })
      .then(({ result }) => result as Channel[])
      .then((channels) => {
        return channels.filter(Boolean).map((channel) => {
          return {
            ...channel,
            LastMessageTimestamp:
              channel.LastMessageTimestamp &&
              new Date(channel.LastMessageTimestamp)
          };
        });
      });
  }
}

export default GetListChannelsApi;
